import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';

export const useNavItemLayout = (): {
  isLaptopAndAbove: boolean;
  navItemsVariant: 'horizontal' | 'vertical';
  iconSize: 2 | 2.5;
} => {
  const isLaptopAndAbove = useIsLaptop();

  return {
    isLaptopAndAbove,
    navItemsVariant: isLaptopAndAbove ? 'horizontal' : 'vertical',
    iconSize: isLaptopAndAbove ? 2 : 2.5,
  };
};
